<!--
 * @Description: 返回报名成功页
 * @Author: 山淑兰
 * @Date: 2019-12-16 10:41:17
 * @LastEditTime: 2020-07-15 16:22:01
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="foot-nav">
        <ul class="fnav">
            <li v-if="navShow">
                <a :href="homeUrl" :class="activeShow1?'active':''">
                    <img src="../../../assets/home-2.png">
                    首页
                </a>
            </li>
            <li>
                <a @click="hotelOrder" :class="activeShow2?'active':''">
                    <img src="../../../assets/jiudian.png">
                    酒店预定
                </a>
            </li>
            <li>
                <a @click="myOrder" :class="activeShow3?'active':''">
                    <img src="../../../assets/order.png">
                    我的订单
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
import publicSignup from '../../../lib/signUp.js'
export default {
    name: 'navigation',
    data() {
      return {
        navShow: true,
        homeUrl: '',
        activeShow1: false,
        activeShow2: false,
        activeShow3: false,
        publicSignup: {}, //通用js
      }
    },
	
    created() {
        this.params = this.$route.query
        this.publicSignup = new publicSignup()
        //console.log(this.publicSignup)
        let opt = { m: this.params.m }
        this.initmeeting(opt)
    },
    methods: {
        async initmeeting(opt) {
            this.show = true
            this.meetingInfo = await this.publicSignup.init(opt, this)
            if (this.meetingInfo.Code === 1000) {
                this.show = false
                if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
                    this.navShow = false
                } else {
                    this.navShow = true
                    this.homeUrl = this.meetingInfo.HomeUrl
                }
            } else {
                this.$notify({
                    massage: this.meetingInfo.Msg,
                    type: 'danger',
                    duration: '3000',
                })
            }
        },
        hotelOrder() {
            let opt = { m: this.params.m }
            this.$router.push({
                path: '/hotelList',
                query: opt
            })
            this.activeShow1 = false
            this.activeShow2 = true
            this.activeShow3 = false
        },
        myOrder(){
            let opt = { m: this.params.m }
            this.$router.push({
                path: '/hotelOrderList',
                query: opt
            })
            this.activeShow1 = false
            this.activeShow2 = false
            this.activeShow3 = true
        },
    },
}
</script>
<style scoped lang="scss">
.foot-nav {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 75px;
    padding: 5px 0;
    background: #fff;
    box-shadow: 0 2px 12px rgba(0,0,0,0.04);

    .fnav {
        width: 100%;
        height: 75px;
        display: flex;
        font-size: 22px;

        li {
            flex: 1;
            text-align: center;
            color: #64748b;
            border-right: 1px solid #e2e8f0;

            a {
                color: #64748b;
                display: block;
                width: 100%;
                height: 100%;
            }
            a.active{
                color: #3b82f6;
            }
            img {
                display: block;
                width: 40px;
                height: 40px;
                margin: 0 auto;
            }
        }

        li:last-child {
            border-right: none;
        }
    }
}
</style>